import React, { useEffect, useState } from 'react'
import history from '@/services/history'
import { Body, Subtitle, Description, Wrapper, AlignRight } from '../styles'
import { Col, Row } from 'react-grid-system'
import {
  Background,
  Panel,
  Table,
  Input,
  Content,
  OrderIcon,
  Spinner,
  Pagination,
  PageHeader,
} from 'presentation/components'
import { Button } from 'presentation/components/atoms'
import paginatorMethods from '@/utils/paginatorMethods'
import { Grid } from 'presentation/components/atoms/grid'
import { Search } from 'presentation/components/molecules/search'
import useDebounce from 'main/hooks/useDebouce'
import { getEmployeesForCardSecondCopy } from '@/services/employeesServices'
import useService from 'main/hooks/useService'
import bff from 'services/bff'
import { useAddCartItem } from 'main/hooks/useAddCartItem'
import { usePaginationOld } from 'main/hooks/usePaginationOld'

const NewCard = () => {
  const debounce = useDebounce()
  const [selected, setSelected] = useState([])
  const [isWaitingResponse, setIsWaitingResponse] = useState(false)
  const { addToCart } = useAddCartItem()

  const query = {
    Sort: 'fullname',
  }
  const { paginator, setPaginator } = usePaginationOld({ query })

  const [getEmployeesForSecondCopyState, getEmployeesForSecondCopyRequest] = useService(getEmployeesForCardSecondCopy, {
    onError: () => history.goBack(),
    onCompleted: (res) => {
      const pageInfo = res?.data
      setPaginator(
        paginatorMethods.updatePaginator(paginator, {
          page: pageInfo?.pageNumber ? pageInfo?.pageNumber : 1,
          pageSize: pageInfo?.pageSize ? pageInfo?.pageSize : 10,
          totalPages: pageInfo?.totalPages ? pageInfo?.totalPages : 1,
          totalItens: pageInfo?.totalItens ? pageInfo?.totalItens : 0,
        }),
      )
    },
  })

  const employeesData = getEmployeesForSecondCopyState.response?.data?.data
  const isLoading = isWaitingResponse || getEmployeesForSecondCopyState.loading

  useEffect(() => {
    paginator.doRequest && getEmployeesForSecondCopyRequest(paginatorMethods.buildQuery(paginator))
    // eslint-disable-next-line
  }, [paginator])

  const handleCheckClick = (id) => {
    const newArray = [...selected]
    const inSelected = newArray.indexOf(id)
    if (inSelected > -1) {
      newArray.splice(inSelected, 1)
      setSelected(newArray)
    } else {
      newArray.push(id)
      setSelected(newArray)
    }
  }

  const generateTableRow = () => {
    return employeesData
      ? employeesData.map((employee) => (
          <Table.Tr key={employee.id}>
            <Table.Td>
              <Input.CheckBox
                checked={selected.includes(employee.id)}
                controlled
                onClick={() => handleCheckClick(employee.id)}
              />
            </Table.Td>
            <Table.Td>{employee.number}</Table.Td>
            <Table.Td>{employee.fullname}</Table.Td>
            <Table.Td>{employee.registration}</Table.Td>
          </Table.Tr>
        ))
      : null
  }

  const requestOrder = async () => {
    if (selected.length < 1) return
    setIsWaitingResponse(true)
    try {
      const response = await bff.post(`/cards/new/second`, selected)

      history.push({
        pathname: '/cartoes/novo/segunda_confirmacao',
        state: {
          orderId: response?.data,
          bypass: true,
          title: 'Cartão 2ª via',
          quantity: employeesData?.length,
          operatorCardName: 'Cartão 2ª via',
        },
      })
      setIsWaitingResponse(false)
    } catch (e) {
      setIsWaitingResponse(false)
      return false
    }
  }

  const requestAddToCart = async () => {
    if (selected.length < 1) return
    setIsWaitingResponse(true)
    try {
      const response = await bff.post(`/cards/new/second`, selected)

      addToCart.mutate({ orderId: response?.data })
      setIsWaitingResponse(false)
    } catch (e) {
      setIsWaitingResponse(false)
      return false
    }
  }

  return (
    <Background>
      <Content>
        <Panel noPadding>
          <PageHeader>Novo Pedido de Cartão</PageHeader>
          <Body>
            <Subtitle>Pedido 2ª Via</Subtitle>
            <Description>
              Selecione abaixo os cartões que deseja fazer o pedido de <strong>2ª via de cartão</strong>
            </Description>
            <Grid container sx={{ marginBottom: '20px' }}>
              <Grid item sm={12} md={6} lg={4}>
                <Search
                  placeholder='Buscar na tabela abaixo...'
                  onSearch={(value) =>
                    debounce(() =>
                      setPaginator(
                        paginatorMethods.setFilters(paginator, {
                          filterProps: 'registration,fullname,cpf',
                          filterValue: value,
                        }),
                      ),
                    )
                  }
                />
              </Grid>
            </Grid>
            {isLoading ? (
              <Spinner.Box>
                {' '}
                <Spinner />{' '}
              </Spinner.Box>
            ) : (
              <>
                <Table loading={isLoading}>
                  <thead>
                    <Table.Tr>
                      <Table.Th>
                        <Input.CheckBox
                          checked={selected?.length === employeesData?.length}
                          controlled
                          onClick={() => {
                            if (selected?.length === employeesData?.length) {
                              setSelected([])
                            } else {
                              setSelected(employeesData.map((employee) => employee.id))
                            }
                          }}
                        />
                      </Table.Th>
                      <Table.Th>
                        <Wrapper>Cartão</Wrapper>
                      </Table.Th>
                      <Table.Th>
                        <Wrapper>
                          Colaborador
                          <OrderIcon
                            clickUp={() => {
                              setPaginator(
                                paginatorMethods.setFilters(paginator, {
                                  sort: 'fullname',
                                }),
                              )
                            }}
                            clickDown={() => {
                              setPaginator(
                                paginatorMethods.setFilters(paginator, {
                                  sort: 'fullname',
                                  desc: true,
                                }),
                              )
                            }}
                          />
                        </Wrapper>
                      </Table.Th>
                      <Table.Th>
                        <Wrapper>
                          Matrícula
                          <OrderIcon
                            clickUp={() => {
                              setPaginator(
                                paginatorMethods.setFilters(paginator, {
                                  sort: 'registration',
                                }),
                              )
                            }}
                            clickDown={() => {
                              setPaginator(
                                paginatorMethods.setFilters(paginator, {
                                  sort: 'registration',
                                  desc: true,
                                }),
                              )
                            }}
                          />
                        </Wrapper>
                      </Table.Th>
                    </Table.Tr>
                  </thead>
                  <tbody>{generateTableRow()}</tbody>
                </Table>
                <Row justify='between'>
                  <Col
                    sm={12}
                    md={4}
                    lg={4}
                    style={{
                      marginTop: '20px',
                    }}
                  >
                    <Pagination.Footer paginator={paginator} />
                  </Col>
                  <Col
                    sm={12}
                    md={4}
                    lg={4}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginTop: '20px',
                    }}
                  >
                    <Pagination
                      paginator={paginator}
                      setPage={(wantedPage) => setPaginator(paginatorMethods.setPage(paginator, wantedPage))}
                    />
                  </Col>
                </Row>

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <AlignRight>
                    <Button onClick={() => history.goBack()}>Voltar</Button>
                    <Button variant='outlined' onClick={() => requestOrder()}>
                      Comprar agora
                    </Button>
                    <Button onClick={() => requestAddToCart()} variant='contained'>
                      Adicionar ao carrinho
                    </Button>
                  </AlignRight>
                </div>
              </>
            )}
          </Body>
        </Panel>
      </Content>
    </Background>
  )
}

export default NewCard
